<template>
  <context-menu>
    <div class="d-flex flex-column">
      <e-btn v-if="props.canEdit" size="M" variant="context" @click="edit">
        <template #prepend>
          <e-icon name="editPen" />
        </template>
        Редактировать
      </e-btn>
      <delete-user-confirmation-dialog v-if="props.canDelete" :user-info="userInfo">
        <template #activator>
          <e-btn v-if="userInfo.id !== profile?.id" variant="context" size="M" class="text-red justify-start w-100">
            <template #prepend>
              <e-icon name="trash" />
            </template>
            Удалить
          </e-btn>
        </template>
      </delete-user-confirmation-dialog>
    </div>
  </context-menu>
</template>

<script setup lang="ts">
import ContextMenu from '@/core/components/common/ContextMenu.vue';
import { EBtn, EIcon } from '@/core/components/ui';
import { useAuthStore } from '@/parts/auth/store/auth';
import DeleteUserConfirmationDialog from '@/parts/users/components/DeleteUserConfirmationDialog.vue';

const props = defineProps<{
  userInfo: {
    id: string;
    name: string;
    lastName: string;
    middleName: string | null | undefined;
  };
  canDelete?: boolean;
  canEdit?: boolean;
}>();

const emit = defineEmits<{
  (event: 'edit', id: string): void;
}>();

const { profile } = useAuthStore();

const edit = () => {
  emit('edit', props.userInfo.id);
};
</script>

<style scoped lang="scss"></style>
